module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p8-27bb57784380928ba559123930c148e0.png";